// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/elementos_documentos_pdf/list
 * and GET /config/elementos_documentos_pdf/buscar_elementos.
 *
 * Returns the list of PDF page-element records sourced from the external
 * html2pdf micro-service via chama_servico(). Each row is typed by the
 * sibling ElementosDocumentosPdf_ListRow contract.
 */
import type { ElementosDocumentosPdf_ListRow } from './ElementosDocumentosPdf_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ElementosDocumentosPdf_ListResponseDados = ElementosDocumentosPdf_ListRow[];

export type ElementosDocumentosPdf_ListResponse = ApiResponse<ElementosDocumentosPdf_ListResponseDados>;

registerResponseContract('ElementosDocumentosPdf_ListResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'number',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'string',  required: false },
      type:      { type: 'string',  required: false },
      name:      { type: 'string',  required: false },
      data:      { type: 'string',  required: false },
    },
  },
})
